import { Box, Grid } from "@mui/material";
import PTTypography from "./PTTypography";
import PTTooltip from "./PTTooltip";
import PTIcon from "./PTIcon";
import PTTranslate from "./PTTranslate";

export const PTFormInput = (props) => {
  const { name, label, required, hiddenLabel, labelSize = 14, mbLabelSize = 8, tooltip, isHidden = () => false, children, ...other } = props;
  
  if (!name) throw new Error("name is required for inputs");
  const shouldHide = typeof isHidden === "function" ? isHidden() : isHidden;
  if (shouldHide) return null;
  return (
    <Grid item key={name} {...other}>
      {!hiddenLabel && (
        <PTTypography
          gutterBottom
          color="primary"
          style={{
            display: "inline-flex",
            alignItems: "center",
            marginLeft: 7,
            fontSize: {md: `${labelSize}px`, xs: `${mbLabelSize}px`},
          }}
        >
          <PTTranslate tk={label} /> {required && <span style={{ color: "red" }}>*</span>}
          {tooltip && (
            <PTTooltip title={tooltip}>
              <Box
                style={{
                  marginLeft: 3,
                  display: "inline-block",
                  borderRadius: "50%",
                  backgroundColor: "#F1F1F1",
                  padding: 2,
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                marginTop: "-10px"
                }}
              >
                <PTIcon
                  icon={"QuestionMarkIcon"}
                  sx={{ height: 8, width: 8 }}
                />
              </Box>
            </PTTooltip>
          )}
        </PTTypography>
      )}
      {children}
    </Grid>
  );
};

export default PTFormInput;
